module.exports = __webpack_public_path__ + "static/media/img-imobiliarias.257fc208.jpg";